import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "el-dropdown-link" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16",
  width: "16",
  height: "16",
  "aria-label": "Angle icon",
  class: "icon icon-angle"
}, [
  /*#__PURE__*/_createElementVNode("path", { d: "M15.14,6.29c.47-.47,.47-1.22,0-1.68-.23-.23-.54-.35-.87-.35s-.64,.13-.87,.35l-4.54,4.43c-.23,.23-.54,.35-.87,.35s-.64-.13-.87-.35L2.59,4.6c-.48-.47-1.25-.47-1.73,0s-.48,1.22,0,1.69l4.55,4.41c1.43,1.4,3.76,1.4,5.19,0l4.55-4.41Z" })
], -1)
const _hoisted_3 = ["href"]
const _hoisted_4 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _renderSlot(_ctx.$slots, "default", { meetingLabelWithoutYear: _ctx.meetingLabelWithoutYear }),
    _createVNode(_component_el_dropdown, { trigger: "click" }, {
      dropdown: _withCtx(() => [
        _createVNode(_component_el_dropdown_menu, null, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item) => {
              return (_openBlock(), _createBlock(_component_el_dropdown_item, null, {
                default: _withCtx(() => [
                  (item.nav_title)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: item.slug
                      }, _toDisplayString(item.nav_title), 9, _hoisted_3))
                    : (item.title)
                      ? (_openBlock(), _createElementBlock("a", {
                          key: 1,
                          href: item.slug
                        }, _toDisplayString(item.title), 9, _hoisted_4))
                      : _createCommentVNode("", true)
                ]),
                _: 2
              }, 1024))
            }), 256))
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_1, [
          _createTextVNode(_toDisplayString(_ctx.activeLabel) + " ", 1),
          _hoisted_2
        ])
      ]),
      _: 1
    })
  ], 64))
}